var _circle, _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoCards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 164"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 15,
    cy: 14.7766,
    r: 14.5,
    fill: "#FF9901",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1212_2871",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 6.5,
    y: 5.27661,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1212_2871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit_card_off"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1212_2871",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 16,
    height: 17
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box_2",
    x: 7,
    y: 7.27661,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1212_2871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "credit_card_off_2",
    d: "M21.5167 19.8932L20.3334 18.7099V15.2766H16.9L14.2333 12.6099H20.3334V11.2766H12.9L11.5667 9.94325H20.3334C20.7 9.94325 21.0139 10.0738 21.275 10.3349C21.5361 10.596 21.6667 10.9099 21.6667 11.2766V19.2766C21.6667 19.3877 21.6556 19.496 21.6334 19.6016C21.6111 19.7071 21.5722 19.8044 21.5167 19.8932ZM13.1 15.2766H9.66668V19.2766H17.1L13.1 15.2766ZM20.6334 22.8099L18.4333 20.6099H9.66668C9.30002 20.6099 8.98613 20.4794 8.72502 20.2182C8.46391 19.9571 8.33335 19.6432 8.33335 19.2766V11.2766C8.33335 10.9099 8.46391 10.596 8.72502 10.3349C8.98613 10.0738 9.30002 9.94325 9.66668 9.94325L11 11.2766H9.66668V12.6099H10.4333L7.43335 9.60991L8.38335 8.65991L21.5834 21.8599L20.6334 22.8099Z",
    fill: "#FF9901"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCards);
export default __webpack_public_path__ + "static/media/no-cards.0a5a953cf623295a77f2dfd4a3ff9f37.svg";
export { ForwardRef as ReactComponent };